import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import Questionnaire from "./Questionnaire";
import { useSurveyMode } from "../../contexts/SurveyModeProvider";

export default function Survey() {
  const { showSurvey, handleCloseSurvey } = useSurveyMode();

  return (
    <>
      <Navbar expand={false} className="mb-3">
        <Container fluid>
          <Offcanvas
            style={{ margin: 0, width: '33%'}}
            show={showSurvey}
            onHide={handleCloseSurvey}
            id={`offcanvasNavbar-expand-false`}
            aria-labelledby={`offcanvasNavbarLabel-expand-false`}
            placement="end"
            className="bg-light"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id={`offcanvasNavbarLabel-expand-false`} style={{color:'#093a73', fontWeight: 200, fontSize: 24, marginLeft: 10, marginTop: 5}}>
                Infection History Evaluation
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body style={{ marginLeft: 10, marginRight: 20}}>
              <Questionnaire />
            </Offcanvas.Body>
          </Offcanvas>
        </Container>
      </Navbar>
    </>
  );
}
